import React from "react";
import { defaultAction } from "@actions/defaultAction";
import { CHANGE_BUY_SEARCH_TEXT } from "@constants/actionTypes";
import styled from "@emotion/styled";
import {
  ClearedStyleButton,
  ClearedStyleRouterLink
} from "@modules/Components";
import { useDispatch } from "react-redux";

const ButtonDiv = styled(ClearedStyleButton)`
  width: 218px;
  height: 60px;
  border-radius: 36px;
  box-shadow: 0 9px 18px 0 rgba(31, 32, 33, 0.05);
  background-color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ff9c1b;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  &:hover {
    background-color: #fff9ef;
    color: #ff9c1b;
  }
`;

const GiftCenterAd = ({ text }) => {
  const dispatch = useDispatch();

  return (
    <ClearedStyleRouterLink
      onClick={() => dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""))}
      to="/buy-gift-cards"
      className="new-gift-card-button-router-link"
    >
      <ButtonDiv className="new-gift-card-button-div">{text}</ButtonDiv>
    </ClearedStyleRouterLink>
  );
};
export default GiftCenterAd;
